module.exports = __webpack_public_path__ + "img/avatar.b1e37c3b.png";